
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('email-action-check')]),_c('circle',{staticClass:"a",attrs:{"cx":"17.25","cy":"17.25","r":"6"}}),_c('path',{staticClass:"a",attrs:{"d":"M19.924,15.506l-2.905,3.873a.752.752,0,0,1-1.131.081l-1.5-1.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M8.25,15.75h-6a1.5,1.5,0,0,1-1.5-1.5v-12A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5V9"}}),_c('path',{staticClass:"a",attrs:{"d":"M21.411,1.3,13.267,7.564a3.308,3.308,0,0,1-4.034,0L1.089,1.3"}})])])
          )
        }
      }
    